<div class="reviewer-feedback-wrapper" *ngIf="current else loading">
    <replay-responses #response [currentAttempt]='current' *ngIf="current" (getQuestion)="currentQuestion($event)">
        <div class="form-group feedback-form" *ngIf="current.reviewer">
            <h2 class="title reviewer-title">{{'interviews.Reviewer Feedback' | translate}}</h2>
            <div class="read-only" *ngIf="currentFeedback && !editFeedback">
                <div class="hint">{{'interviews.Your feedback has been submitted!' | translate}}</div>
                <feedback *ngIf="currentFeedback" class="feedback" [data]="currentFeedback"></feedback>
                <div class="buttonbar buttonbar-bottom clearfix">
                    <button class="btn btn_secondary pull-right submit-feedback" (click)="editCurrentFeedback()">
                        {{'interviews.Edit Feedback' | translate}}
                    </button>
                    <button *ngIf="question === current.questions[current.questions.length - 1]" (click)="form.valid && addFeedback()" class="btn btn_primary pull-right submit-feedback">
                        {{'interviews.Review and Send' | translate}}
                    </button>
                </div>
            </div>
            <form *ngIf="!currentFeedback || (currentFeedback && editFeedback)" [formGroup]="form"
                  (ngSubmit)="form.valid && addFeedback(form)">
                <div class="feedback-rating">
                    <h5 class="feedback-rating-title">{{'interviews.Rater Answer' | translate}}</h5>
                    <a href="javascript:void(0)" (click)="clearRating()" class="reset-rating">
                        <i class="icn icn-reset"></i>
                    </a>
                    <div class="ratings-form">
                        <fieldset class="rating">
                            <input type="radio" [name]="ratings" formControlName="ratings" value="5"
                                   [checked]="rating==5"/>
                            <label title="{{'interviews.5 stars' | translate}}" (click)='onClick(5)'>{{'interviews.5
                                stars' | translate}}</label>

                            <input type="radio" [name]="ratings" formControlName="ratings" value="4"
                                   [checked]="rating==4"/>
                            <label title="{{'interviews.4 stars' | translate}}" (click)='onClick(4)'>{{'interviews.4
                                stars' | translate}}</label>

                            <input type="radio" [name]="ratings" formControlName="ratings" value="3"
                                   [checked]="rating==3"/>
                            <label title="{{'interviews.3 stars' | translate}}" (click)='onClick(3)'>{{'interviews.3
                                stars' | translate}}</label>

                            <input type="radio" [name]="ratings" formControlName="ratings" value="2"
                                   [checked]="rating==2"/>
                            <label title="{{'interviews.2 stars' | translate}}" (click)='onClick(2)'>{{'interviews.2
                                stars' | translate}}</label>

                            <input type="radio" [name]="ratings" formControlName="ratings" value="1"
                                   [checked]="rating==1"/>
                            <label title="{{'interviews.1 star' | translate}}" (click)='onClick(1)'>{{'interviews.1
                                star' | translate}}</label>
                        </fieldset>
                    </div>
                </div>
                <div class="form-group">
                    <textarea class="form-control"
                              id="feedback-comment" rows="3"
                              formControlName="review"
                              [ngClass]="{'is-invalid':form.get('review').touched && form.get('review').invalid}">
                    </textarea>
                </div>
                <div class="buttonbar buttonbar-bottom clearfix" [ngSwitch]="question === current.questions[current.questions.length - 1]">
                    <button *ngSwitchCase="true" class="btn btn_primary pull-right submit-feedback">
                        {{'interviews.Review and Send' | translate}}
                    </button>
                    <div *ngSwitchDefault>
                        <button class="btn btn_primary pull-right submit-feedback">{{'interviews.Save and Continue' |
                            translate}}
                        </button>
                    </div>
                    <button *ngIf="editFeedback" class="btn btn_secondary pull-right submit-feedback"
                            (click)="editFeedback = false">{{'interviews.Cancel' | translate}}
                    </button>
                </div>
            </form>
        </div>
    </replay-responses>
</div>
<ng-template #loading>{{'interviews.Loading...' | translate}}</ng-template>
